import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderEvaluationSubmission = createSelector(
  [(state: AppState) => state.externalProvider.evaluationSubmission],
  state => state,
);
